<h2>Sales By Location</h2>
<ag-grid-angular 
	style="width: auto; height: auto; margin: 20px 0px;" 
	class="ag-theme-balham"
	[gridOptions]="gridOptions"
	[rowData]="resRevByDay" 
	(gridReady)="onGridReady($event)"
	(firstDataRendered)="onFirstDataRendered($event)"
	[groupDefaultExpanded]="groupDefaultExpanded"
	(rowGroupOpened)="onRowGroupOpened($event)"
>
</ag-grid-angular>